<template>
  <div>

    <!-- 搜索 -->
    <van-search
      v-model="childValue"
      placeholder="营员搜索"
      @search="childSearch"
    />
    <!-- /搜索 -->

    <van-tabs
      v-model="active"
      @click="onClickTab"
    >
      <van-tab
        title="进行中活动"
        name="0"
      >

        <div
          v-show="List!=null"
          v-cloak
        >
          <div
            v-if="List&&List.length>0"
            style="padding:  15px  20px 60px"
          >

            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div
                v-for="(item,index) in List"
                :key="index"
                class="css-display"
              >
                <div style="text-align: center;font-size: 20px;font-weight: 700;padding: 0 10px;background-color:#ffffff;">
                  {{item.party_title}}
                </div>

                <div class="p10-size14">
                  <div class="title-s">开始日期</div>
                  <div class="value-s">{{item.date_start}}</div>
                </div>
                <div class="p10-size14">
                  <div class="title-s">结束日期</div>
                  <div class="value-s">{{item.date_end}}</div>
                </div>
                <div style="padding:10px 10px 0;">
                  <button
                    @click="skipDetail(item)"
                    class="buto"
                  >进入</button>
                </div>

              </div>

            </van-list>

          </div>
          <div v-show="List.length==0&&listShow">
            <van-empty description="暂无信息" />
          </div>
        </div>

      </van-tab>
      <van-tab
        title="未开始活动"
        name="1"
      >
        <div v-show="List!=null">
          <div
            v-if="List&&List.length>0"
            style="padding:  15px  20px 60px"
          >

            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div
                v-for="(item,index) in List"
                :key="index"
                class="css-display"
              >
                <div style="text-align: center;font-size: 20px;font-weight: 700;padding: 0 10px;background-color:#ffffff;">
                  {{item.party_title}}
                </div>

                <div class="p10-size14">
                  <div class="title-s">开始日期</div>
                  <div class="value-s">{{item.date_start}}</div>
                </div>
                <div class="p10-size14">
                  <div class="title-s">结束日期</div>
                  <div class="value-s">{{item.date_end}}</div>
                </div>

                <div style="padding:10px 10px 0;">
                  <button
                    @click="skipDetail(item)"
                    class="buto"
                  >进入</button>
                </div>

              </div>

            </van-list>

          </div>
          <div v-show="List.length==0&&listShow">
            <van-empty description="暂无信息" />
          </div>
        </div>
      </van-tab>
      <van-tab
        title="已结束活动"
        name="2"
      >
        <div v-show="List!=null">
          <div
            v-if="List&&List.length>0"
            style="padding:  15px  20px 60px"
          >

            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div
                v-for="(item,index) in List"
                :key="index"
                class="css-display"
              >
                <div style="text-align: center;font-size: 20px;font-weight: 700;padding: 0 10px;background-color:#ffffff;">
                  {{item.party_title}}
                </div>
                <div class="p10-size14">
                  <div class="title-s">开始日期</div>
                  <div class="value-s">{{item.date_start}}</div>
                </div>
                <div class="p10-size14">
                  <div class="title-s">结束日期</div>
                  <div class="value-s">{{item.date_end}}</div>
                </div>
                <div style="padding:10px 10px 0;">
                  <button
                    @click="skipDetail(item)"
                    class="buto"
                  >进入</button>
                </div>

              </div>

            </van-list>

          </div>
          <div v-show="List.length==0&&listShow">
            <van-empty description="暂无信息" />
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <myFoot></myFoot>
    <!-- 返回顶部 -->
    <backTop ref="bt"></backTop>

  </div>

</template>
<script>
import { Toast } from 'vant'
export default {
  data() {
    return {
      List: null,
      active: '0',
      loading: false,
      finished: false,
      page: 0,
      tabsName: '进行中活动',
      total: 0,
      listShow: false,
      childValue: '',
    }
  },

  created() {
    this.reload(this.tabsName)
  },
  mounted() {},
  methods: {
    reload(process) {
      this.page = 0
      this.List = []
      this.loading = false
      this.finished = false
      this.getListInfo(process)
    },
    onLoad() {
      let that = this

      if (this.List.length == this.total) {
        that.loading = false
        that.finished = true
        return
      }
      setTimeout(() => {
        this.getListInfo(that.tabsName)
      }, 500)
    },
    getListInfo(title) {
      let that = this
      let process = null
      switch (title) {
        case '进行中活动':
          process = '1'
          break
        case '未开始活动':
          process = '0'
          break
        case '已结束活动':
          process = '-1'
          break
      }
      that.page++
      this.$axios
        .get('/project/list', {
          params: {
            process: process,
            page: that.page,
          },
        })
        .then((res) => {
          let data = res.data.data
          for (let i = 0; i < data.length; i++) {
            data[i].party_title = this.Ellipsis(data[i].party_title, 10)
            this.List.push(data[i])
          }

          this.total = res.data.total
          // this.List = this.List.contat(data)
          that.loading = false
          if (res.data.data.length == 0) {
            this.listShow = true
            that.finished = true
          }
        })
    },
    onClickTab(name, title) {
      this.tabsName = title
      this.reload(title)
    },
    skipDetail(item) {
      //type 进入队伍的页面 1=> 大队长页面  2 => 中队长页面  3 =>小队长页面
      let type = item.team_type
      switch (type) {
        case 1:
          this.$router.push({
            path: '/posDetail',
            query: {
              project_id: item.id,
            },
          })
          break
        case 2:
          this.$router.push({
            path: '/lochus',
            query: {
              project_id: item.id,
              team2_id: item.team_id,
            },
          })
          break
        case 3:
          this.$router.push({
            path: '/camper',
            query: {
              project_id: item.id,
              team3_id: item.team_id,
            },
          })
          break
        case 0:
          Toast('暂未分配职位,无法查看队伍')
          break
      }
    },
    Ellipsis(value, length) {
      if (!value) return ''
      // 判断如果不是字符串的话那么就把他转换成字符串截取
      if (typeof value !== String) {
        value = value.toString()

        if (value.length > length) {
          return value.slice(0, length) + '...'
        }
      }

      return value
    },
    childSearch(e) {
      this.$router.push({
        path: '/itemSearch',
        query: {
          childValue: this.childValue,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.position {
  background-color: #f1f1f1;
}
/deep/ .van-card {
  background-color: #fff;
}

.css-display {
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #f1f1f1;
  padding: 10px;
  font-size: 15px;
  border-radius: 10px;
  box-shadow: 2px 2px 4px rgba($color: #4c4d47, $alpha: 0.5);
  margin-bottom: 10px;
}
.buto {
  background-color: royalblue;
  padding: 5px 20px;
  border: none;
  border-radius: 6px;
  color: #fff;
}
.p10-size14 {
  padding: 12px 15px;
  font-size: 14px;

  .title-s {
    display: inline-block;
    width: 35%;
    font-weight: 500;
    // color: brown;
    // text-align: center;
  }

  .value-s {
    display: inline-block;
    color: #999;
    width: 65%;
    text-align: right;
  }
}
</style>